import React, { useState } from "react";
import "./MobileNavMenu.css";
import logo from "../../Images/logo.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faMagnifyingGlass,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import Cart from "../Cart/Cart";
import { Link } from "react-router-dom";
import PopCart from "../PopCart/PopCart";
import NavLogin from "../NavLogin/NavLogin";
import MobileSearch from "../MobileSearch/MobileSearch";
import MobileCategory from "../MobileCategory/MobileCategory";

const MobileNavMenu = ({ popCart, handlePopCart }) => {
  const [userLogin, setUserLogin] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const otpUser = JSON.parse(localStorage.getItem("user"));
  const [menu, setMenu] = useState(false);

  const handleUserLogin = () => {
    setUserLogin(!userLogin);
    setShowSearch(false);
  };

  const handleSearch = (search) => {
    setShowSearch(search);
  };

  const handleMenu = (menu) => {
    setMenu(menu);
    setShowSearch(false);
    if (menu) {
      handlePopCart(false);
    }
  };

  if (popCart || userLogin || showSearch || menu) {
    if (window.innerWidth < 640) {
      document.body.style.overflow = "hidden";
    }
  } else {
    document.body.style.overflow = "visible";
  }

  return (
    <div
      className={`mobile-menu-container ${
        showSearch ? "searched-nav-menu" : ""
      }`}
    >
      <div className="flex ">
        <FontAwesomeIcon
          className="text-secondary mr-8 text-xl"
          icon={faBars}
          onClick={() => handleMenu(true)}
        ></FontAwesomeIcon>
        <MobileCategory menu={menu} handleMenu={handleMenu} />
      </div>

      <Link to="/">
        <p className="text-2xl font-bold bg-gradient-to-r from-[#1C5E99] to-[#1DBFF8] bg-clip-text text-transparent">
          MUSFIQ TRADING
        </p>
      </Link>

      <div className="ml-auto mr-2">
        <FontAwesomeIcon
          onClick={() => handleSearch(!showSearch)}
          className="text-secondary text-xl"
          icon={faMagnifyingGlass}
        ></FontAwesomeIcon>
        <MobileSearch
          showSearch={showSearch}
          handleSearch={handleSearch}
        ></MobileSearch>
      </div>
      <span
        className={`overlay ${
          showSearch ? "searched-overlay" : "not-searched-overlay"
        } ${userLogin ? "overlay-active" : ""} ${
          popCart || menu ? "overlay-active " : ""
        }`}
      ></span>
    </div>
  );
};

export default MobileNavMenu;
